import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-actions" }

import { computed, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { quotationConvert } from "@/shared/services/quotations.api";
import { useSnackbarStore } from "@/shared/stores/snackbar";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationConvertActionModal',
  props: {
    quotationId: {},
    onSuccess: { type: Function },
    onConfirm: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const snackbar = useSnackbarStore();
const isSubmitting = ref(false);

const actionColor = computed(() => "success");


async function handleConfirm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    await quotationConvert(props.quotationId);
    snackbar.success("Converted to appointment.");

    if (props.onConfirm) props.onConfirm();
    if (props.onSuccess) props.onSuccess();
    modal.close();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to convert quotation.";
    snackbar.error(message);
  } finally {
    isSubmitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card_text, { class: "modal-body" }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("div", { class: "modal-copy" }, [
            _createElementVNode("p", { class: "modal-title" }, "Convert Appointment"),
            _createElementVNode("p", { class: "modal-subtitle" }, "This will convert the quotation into an appointment.")
          ])
        ], -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_card_actions, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppButtonFlat, {
            size: "small",
            color: "secondary",
            class: "px-6",
            variant: "outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close())),
            disabled: isSubmitting.value
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Cancel ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(AppButtonFlat, {
            size: "small",
            class: "px-6",
            onClick: handleConfirm,
            loading: isSubmitting.value,
            disabled: isSubmitting.value
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Confirm ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})